export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/404/img-not-found-v4-9a93d6f74f1fbc5c398498612f4319cc.svg";